import { render, staticRenderFns } from "./meal_and_attractions_table.vue?vue&type=template&id=202c76b3&"
import script from "./meal_and_attractions_table.vue?vue&type=script&lang=js&"
export * from "./meal_and_attractions_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports